export enum DateFilterDropdownKeys {
    LAST_WEEK = 'LAST_WEEK',
    LAST_15_DAYS = 'LAST_15_DAYS',
    CURRENT_MONTH = 'CURRENT_MONTH',
    LAST_MONTH = 'LAST_MONTH',
    LAST_THREE_MONTH = 'LAST_THREE_MONTH',
    LAST_QUARTER = 'LAST_QUARTER',
    LAST_SIX_MONTH = 'LAST_SIX_MONTH'
}
